'use client';

import { useEffect, useMemo, useState } from 'react';
import { usePathname } from '@/i18n/navigation';

type TOptions = {
  /** ключ localStorage */
  key: string;
  /** текст ошибки */
  message?: string;
  /** можно выключать фичу */
  enabled?: boolean;
};

function readLocalStorageString(key: string): string | null {
  try {
    const isCrash = window.localStorage.getItem(key);
    if (!isCrash) return null;
    const trimmed = isCrash.trim();

    return trimmed.length ? trimmed : null;
  } catch {
    return null;
  }
}

/**
 * Инкапсулированный хук: если в localStorage[key] содержится название страницы,
 * то крашит эту страницу (через throw в render).
 */
export function useCrashOnLocalStorageFlag({
  key,
  message = 'Forced crash by localStorage page flag',
  enabled = true,
}: TOptions) {
  const pathnameRaw = usePathname() || '';
  const pathname = useMemo(() => pathnameRaw, [pathnameRaw]);

  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    setTarget(readLocalStorageString(key));
  }, [key, enabled, pathname]);

  const shouldCrash = enabled && !!target && pathname.includes(target);

  if (shouldCrash) {
    throw new Error(`${message}. target="${target}", pathname="${pathname}"`);
  }
}
